import { BaseValidatorOptions, Validator } from '@philips-internal/oswald-ui-core/lib/services/model-service';

export const InsuranceFields = {
  required
}

function required(options?: BaseValidatorOptions): Validator {
  return {
    name: 'required',
    options,
  }
}
